<template>
  <div class="k-purchases-wrapper">
    <div class="main-menu__wrapper">
      <div class="nav justify-content-center main-menu main-menu--always-bordered">
        <span
          class="nav-item main-menu__item-wrapper"
          :class="{ active: currentTab === 'ingredients' }"
          @click="currentTab = 'ingredients'"
        >
          <span class="main-menu__item nav-link">Ингредиенты</span>
        </span>
        <span
          class="nav-item main-menu__item-wrapper"
          :class="{ active: currentTab === 'recipes' }"
          @click="currentTab = 'recipes'"
        >
          <span class="main-menu__item nav-link">Блюда</span>
        </span>
      </div>
    </div>
    <div class="k-card-wrapper col-12">
      <div class="k-purchases k-card mt-4">
        
        <transition name="fade" mode="out-in">
          <component :is="getCurrentComponent"/>
        </transition>

      </div>
    </div>
  </div>
</template>

<script>
import PurchaseCard from '../components/PurchaseCard';
import IngredientsTab from './PurchaseTabs/PurchaseIngredientsTab';
import RecipesTab from './PurchaseTabs/PurchaseRecipesTab';

export default {
  components: {
    PurchaseCard,
    RecipesTab,
    IngredientsTab,
  },
  data: () => ({
    currentTab: "recipes",
    tabs: [
      { tab: 'ingredients', component: IngredientsTab },
      { tab: 'recipes', component: RecipesTab },
    ]
  }),
  computed: {
    getCurrentComponent() {
      return this.tabs.find(el => el.tab === this.currentTab).component;
    },
  },
};
</script>

<style lang="scss">
.k-purchases {
  padding: 50px;
}
.k-purchase__title-first {
  font-weight: 600;
  font-size: 20px;
  color: #616161;
}
.k-purchase__title-second {
  font-weight: 600;
  font-size: 18px;
  color: #616161;
}
.k-purchase__title-additional {
  font-size: 14px;
  color: #616161;
  margin-left: 25px;
}
.k-purchases__content {
  display: flex;
  flex-wrap: wrap;
}

.k-purchases-wrapper {
  padding: 0 60px 60px;
}
.k-purchases__toggle-boughted {
  max-width: 380px;
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid #F68C1E;
  box-sizing: border-box;
  border-radius: 8px;
  color: #F68C1E;
  margin-right: 24px;
  margin-bottom: 4px;

  transition: all .2s linear;
  cursor: pointer;

  &.active {
    border: 1px solid #9DC43B;
    color: #9DC43B;
  }
}

.k-purchases__link-button {
  font-size: 14px;
  color: #F68C1E;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
}

.circle-button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &--red {
    background: #D51E3A;
  }
  &--green {
    background: #9DC43B;
  }
}
.k-purchase__title-description {
  font-size: 16px;
  color: #616161;
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .k-purchases__toggle-boughted {
    width: 100%;
    margin-right: 0;
    max-width: unset;
  }
  .k-purchases {
    padding: 5px;
  }
  .k-purchases-wrapper  {
    padding: 0;
  }
  .k-purchases.k-card {
    background: unset;
    border: unset;
    box-shadow:  unset;
  }
  .main-menu--always-bordered {
    border-bottom: 2px solid #E4E4E4;
    width: 100%;
    .main-menu__item-wrapper {
      width: 50%;
      margin-right: 0;
      display: flex;
      justify-content: center !important;
      border: unset;
      &.active {
        background: unset;
        .main-menu__item {
          border-bottom: 2px solid #F68C1E;
        }
      }
      .main-menu__item {
        color: #000000;
        width: 100%;
        display: flex;
        justify-content: center !important;
      }
    }
  }
}
</style>